import React from 'react';
import { Create } from 'react-admin';
import { CreateHeadTitle } from '../HeadTitle';

const BaseCreate = ({ resourceName, resourceNamePlural, ...props }) => (
    <Create title={<CreateHeadTitle resourceName={resourceName} />} {...props} />
);

export default BaseCreate;
